import React, { FC } from 'react'
import styled from 'styled-components'
import { Box } from '@ucheba/ui/components/Box/touch'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { TextField } from '@ucheba/ui/components/TextField/desktop'
import { EDataKeys } from '@ucheba/utils/types/dataKeys'
import { ErrorText } from '@ucheba/ui/components/ErrorText/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { Formik, Field, ErrorMessage } from 'formik'
import { Form } from '@ucheba/ui/components/Form/desktop'
import { useSelector } from 'react-redux'
import { clientProductsRequestsSelectors } from '@ucheba/store/client-products/requests'
import { Radio } from '@ucheba/ui/components/Radio/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { authPhoneCodeSelectors } from '@ucheba/store/auth/phone/code'
import { EModButtonColor } from '@ucheba/ui/components/Button/types'
import content from '../../AppliactionForm/data.json'
import { IRequestFormProps } from '../types'
import { useRequestForm } from '../bll'
import PhoneConfirmDialog from './PhoneConfirmDialog'
import MessengersDialog from './MessengersDialog'

const Block = styled.div`
  z-index: 3;
  position: relative;
`

const RequestForm: FC<IRequestFormProps> = (props) => {
  const {
    title,
    description,
    children,
    buttonColor = 'gold',
    spacing = 'xlarge',
    onSubmitForm,
    requestTarget,
    funnel,
    productType,
    productId,
  } = props

  const {
    onSubmit,
    isLoading,
    phone,
    needConfirmPhone,
    onPhoneConfirmClose,
    onPhoneConfirmSubmit,
    needShowMessengers,
    onMessengersDialogClose,
    initialValues,
  } = useRequestForm(funnel, productType, requestTarget, onSubmitForm, productId)
  const apiErrors = useSelector(clientProductsRequestsSelectors.error)

  const error = useSelector(authPhoneCodeSelectors.error)

  return (
    <Block>
      <Box spacing={spacing} color='white'>
        {title && <Heading textAlign='center' h2={title} as='h3' spacing='null' />}

        {description && (
          <>
            <Spacing spacing='usmall' />

            <Text textAlign='center' fontSize='large' lineHeight='large'>
              {description}
            </Text>
          </>
        )}

        <Spacing spacing='large' />

        <Formik initialValues={initialValues} onSubmit={onSubmit}>
          {(): JSX.Element => (
            <Form apiErrors={apiErrors}>
              <Field as={TextField} name={EDataKeys.name} label='Имя' required />

              <ErrorMessage component={ErrorText} name={EDataKeys.name} />

              <Spacing spacing='large' />

              <Field
                as={TextField}
                name={EDataKeys.phone}
                label='Телефон'
                required
                type='tel'
              />

              <ErrorMessage component={ErrorText} name={EDataKeys.phone} />

              {error && (
                <>
                  <ErrorText>{error.message}</ErrorText>

                  <Spacing spacing='small' />
                </>
              )}

              <Spacing spacing='large' />

              <Grid spacing='small'>
                <GridCol width='auto'>
                  <Field
                    as={Radio}
                    type='radio'
                    name={EDataKeys.isParent}
                    value='false'
                    label={content.application.fields.enrollee}
                  />
                </GridCol>

                <GridCol width='auto'>
                  <Field
                    as={Radio}
                    type='radio'
                    name={EDataKeys.isParent}
                    value='true'
                    label={content.application.fields.parent}
                  />
                </GridCol>
              </Grid>

              <Spacing spacing='large' />

              <Button
                color={buttonColor as keyof typeof EModButtonColor}
                block
                type='submit'
                progress={isLoading}
              >
                Отправить
              </Button>
            </Form>
          )}
        </Formik>
      </Box>

      {children}

      {phone && needConfirmPhone ? (
        <PhoneConfirmDialog
          open={needConfirmPhone}
          phone={phone}
          onSubmit={onPhoneConfirmSubmit}
          onClose={onPhoneConfirmClose}
          isLoading={isLoading}
        />
      ) : null}
      <MessengersDialog open={needShowMessengers} onClose={onMessengersDialogClose} />
    </Block>
  )
}

export default RequestForm
